;(function () {
    window.Ateed.Components.Tab = function () {

        var tabWidth = 0,
            tabGap = 50;

        function getNavWidth () {
            for (var i = 0; i < $('.ateed-tab .nav-tabs li').length; i++) {
                tabWidth = tabWidth + $('.ateed-tab .nav-tabs li:nth-child(' + (i + 1) + ')').width();
            }
            return Math.floor(tabWidth, 10) + tabGap;
        }

        var navWidth = getNavWidth();
        var bodyWidth = $('.ateed-tab').width();

        function handleToggle () {
            bodyWidth = $('.ateed-tab').width();

            if (navWidth > bodyWidth) {
                $('.tablist-arrow').css('display', 'block');
            }
            else {
                $('.tablist-arrow').css('display', 'none');
            }
        }

        handleToggle();
        $(window).resize(handleToggle);
    };
})();
